import React, { PureComponent } from 'react';
import ReactDropzone from 'react-dropzone';

import classNames from 'classnames';
import { Loader } from 'components/loader';
import PropTypes from 'prop-types';

import './Dropzone.scss';
export default class Dropzone extends PureComponent {
  drop = React.createRef();

  static propTypes = {
    onDrop: PropTypes.func,
    children: PropTypes.node,
    className: PropTypes.string,
    isLoaded: PropTypes.bool,
    inputLabel: PropTypes.string,
    onClick: PropTypes.func
  };

  get isLoaded() {
    const isAlreadyLoaded = typeof this.props.isLoaded === 'undefined';

    return isAlreadyLoaded || this.props.isLoaded;
  }

  render() {
    const { className, children, inputLabel, ...props } = this.props;
    const classComponent = classNames('dropzone', className);

    return (
      <ReactDropzone ref={this.drop} {...props} onClick={this.onClick}>
        {({ getRootProps, getInputProps }) => {
          return (
            <div {...getRootProps()} className={classComponent}>
              {this.isLoaded && (
                <input {...getInputProps()} aria-label={inputLabel} />
              )}
              {this.isLoaded ? children : <Loader />}
            </div>
          );
        }}
      </ReactDropzone>
    );
  }

  openRef = () => {
    this.drop.current.open();
  };

  onClick = (e) => {
    if (this.isLoaded) {
      e.preventDefault();
      e.stopPropagation();
      if (this.props.onClick) {
        this.props.onClick(e);
      } else {
        this.openRef();
      }
    }
  };
}
